module.exports = "<div class=\"wx-default-content\">\n  <div class=\"wx-default-contianer\">\n    <div class=\"iconfont icon-shigongzhong\"></div>\n    <span class=\"text\">页面正在施工中...</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/default/default.html
// module id = ./src/views/default/default.html
// module chunks = 1